exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".google-map[data-v-232ef402] {\n  width: 100%;\n  height: 300px;\n}\n.modal-body[data-v-232ef402] {\n  font-size: 12px;\n}\n", ""]);

// exports
